import React from "react";
import CloseIcon from "@mui/icons-material//Close";
import UncheckedIcon from "@mui/icons-material/CheckBoxOutlineBlank";
import useTranslationCommon from "../useTranslationCommon.js";
import useShowLoader from "../../common/loading-widgets/useShowLoader.js";
import "./FilterOption.scss";

export default function FilterOption(props) {
  const { onClick, index, indexValue, checked, value } = props;

  const { t, loading: tLoading } = useTranslationCommon();
  useShowLoader(tLoading, "JobSearchPane");

  return (
    <>
      <span className="FilterOption">
        <span className="option-col">{value}</span>
        <span className="icon-col">
          {checked ? (
            <CloseIcon onClick={onClick} className="close-icon" />
          ) : (
            <UncheckedIcon />
          )}
        </span>
      </span>
      {indexValue === index ? (
        ""
      ) : (
        <span className="and-span">{t("common:common_or")}</span>
      )}
    </>
  );
}
